import { screenSize } from "@src/theme";
import React from "react";
import styled from "styled-components";
import DashboardTopBar from "../DashboardTopBar";
import SideNavMenu from "../SideNavMenu";

const Container = styled.div`
  background-color: ${(props): string => props.theme.colors.darkBg};
  width: 100%;
  max-width: ${screenSize.desktopXL};
  height: 100vh;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

type WrapperContainerProps = {
  children: React.ReactNode | (() => React.ReactNode);
  noScroll?: boolean;
};
const WrapperContainer = ({
  children,
  noScroll = false,
}: WrapperContainerProps): React.JSX.Element => {
  return (
    <Container>
      <DashboardTopBar />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          flex: 1,
          overflow: "hidden",
        }}
      >
        <SideNavMenu />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            flex: 1,
            overflow: noScroll ? "hidden" : "auto",
          }}
        >
          {typeof children === "function" ? children() : children}
        </div>
      </div>
    </Container>
  );
};

export default WrapperContainer;
